const state = {
  ourservice_banner: [],
};

export default state;
